import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { EmployeeHarvestingJobEdit } from './Pages/listing';

export const EmployeeHarvestingJobEditRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={EmployeeHarvestingJobEdit} />
    </Fragment>
)